module.exports = __webpack_public_path__ + "img/choose.59067326.svg";